const SmallLoadingSpinner = () => (
  <>
  <div className="loadingio-spinner-spin-4ffxh03ubks"><div className="ldio-pazicmv58mg">
  <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
  </div></div>
  </>
);

export default SmallLoadingSpinner;